@if (!pageReady()) {
  <div class="flex flex-col h-full w-full justify-center items-center fixed top-0 bottom-0">
    <app-loading-pae [text]="messageLoading()" />
  </div>
} @else {
  <router-outlet />
}

@if (diagnostics.isActive()) {
  <aside
    class="fixed bottom-5 left-4 right-4 z-[20000] w-auto rounded-xl border border-pae-purple bg-pae-magenta px-5 py-4 text-sm text-pae-white shadow-2xl sm:left-1/4 sm:right-auto sm:w-[min(34rem,calc(50vw-2.5rem))] sm:-translate-x-1/2"
    role="status"
    aria-live="polite">
    <div class="mb-2 flex items-center justify-between gap-4">
      <p class="text-base font-bold">Modo diagnóstico activo</p>
      <span class="shrink-0 rounded-full bg-pae-purple px-3 py-1 text-xs font-semibold">
        {{ diagnostics.requestCount() }}/60 solicitudes
      </span>
    </div>
    <p class="select-all break-all rounded-md bg-pae-purple px-3 py-2 font-mono text-xs">
      Sesión: {{ diagnostics.diagnosticSessionId() }}
    </p>
    @if (diagnostics.lastSupportId()) {
      <p class="mt-2 select-all break-all rounded-md bg-pae-purple px-3 py-2 font-mono text-xs font-semibold">
        Último supportId: {{ diagnostics.lastSupportId() }}
      </p>
    }
    <p class="mt-3 text-xs font-medium">Ctrl + Alt + D para finalizar y descargar el archivo.</p>
  </aside>
}

@if (portalMessagesTycService.isLoadingNewUserTyC() || portalMessagesTycService.isConfirmingNewUserTyC()) {
  <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-pae-grey-5/70">
    <div class="bg-pae-white px-14 py-2 rounded shadow-xl">
      <app-loading-pae
        [text]="
          portalMessagesTycService.isConfirmingNewUserTyC()
            ? 'Confirmando aprobación pendiente...'
            : 'Buscando Aprobación pendiente...'
        " />
    </div>
  </div>
}

<app-alert
  #globalAlert
  [icon]="portalMessagesTycService.alertIcon()"
  [actions]="portalMessagesTycService.alertConfig().actions"
  [titleButton]="portalMessagesTycService.alertConfig().titleButton"
  [variant]="portalMessagesTycService.alertIsPrimaryFlow() ? 'blue' : 'magenta'"
  [cantBeClosed]="portalMessagesTycService.alertIsPrimaryFlow()"
  [route]="portalMessagesTycService.alertConfig().route ?? ''"
  (actionClicked)="onGlobalAlertClicked($event)">
  @if (portalMessagesTycService.alertTitle()) {
    <h3 class="self-center text-2xl text-gray-900">{{ portalMessagesTycService.alertTitle() }}</h3>
  }

  <div class="col-span-2 flex justify-center text-lg">
    <p class="text-center">{{ portalMessagesTycService.alertMessage() }}</p>
  </div>
</app-alert>

<app-modal
  #newUserTyCModal
  [actions]="[{ action: 'approve', title: 'Aceptar' }]"
  [modalSize]="'max-w-7xl'"
  [cantBeClosed]="true"
  actionsAlign="end"
  (actionClicked)="onNewUserTyCAction($event)">
  <div class="flex flex-col w-full">
    <h3 class="text-2xl font-bold text-pae-blue pb-4">Términos y Condiciones Generales</h3>
    <hr class="border-t border-[#dee2e6] mb-4" />

    <div class="max-h-screen overflow-y-auto flex flex-col gap-4">
      @if (portalMessagesTycService.newUserTyCUrl()) {
        <iframe
          [src]="portalMessagesTycService.newUserTyCUrl()"
          class="border-0"
          width="100%"
          height="400px"
          title="Términos y Condiciones Generales"></iframe>
      }

      <hr class="border-t border-[#dee2e6]" />

      <p class="text-md text-slate-700">
        Por medio de la presente quien suscribe (haciendo click en el botón "Aceptar"): (i) declara haber leído los
        términos especiales a los que el presente accede, (ii) acepta los términos especiales y (iii) participará del
        concurso, acción o programa de incentivos conforme lo establecido en los términos y condiciones generales y los
        términos especiales que por la presente se aceptan.
      </p>
    </div>
  </div>
</app-modal>

<app-modal-action #notificationModal [modalSize]="'max-w-4xl'">
  <ng-container content>
    @if (portalMessagesTycService.pendingUnreadNotification(); as notification) {
      <div class="flex flex-col w-full gap-6 pb-2">
        <div class="flex flex-col flex-1 gap-y-0">
          <h3 class="text-2xl text-gray-900 font-semibold">
            {{ notification.subject }}
          </h3>
        </div>

        <div class="flex flex-col flex-1 gap-y-1">
          <h5 class="text-base text-gray-900 font-semibold">
            Recibido {{ notification.createdOn | date: 'dd/MM/yyyy' }}
          </h5>

          <div class="max-h-[70vh] overflow-y-auto flex flex-col gap-4">
            <div [innerHTML]="portalMessagesTycService.notificationMainContentHtml()"></div>
            <div [innerHTML]="portalMessagesTycService.notificationFigureHtml()"></div>
          </div>
        </div>
      </div>
    }
  </ng-container>
  <ng-container action>
    @if (portalMessagesTycService.pendingUnreadNotification()) {
      <button (click)="onNotificationNotified()" type="button" class="btn btn-primary-magenta min-w-[154px]">
        Notificado
      </button>
    }
  </ng-container>
</app-modal-action>

<app-alert
  #viewAlertMessage
  [title]="alertTitle()"
  [description]="[alertMessage()]"
  [icon]="icon()"
  [actions]="['accept']"
  titleButton="Ir al login"
  [cantBeClosed]="true"
  (actionClicked)="onPasswordResetAction($event)">
</app-alert>
